// Browser-side file-save helpers. The API client is JSON-only, so CSV/ZIP
// exports are materialized into a Blob and handed to an anchor click.

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoke on the next tick so the click has a chance to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

function csvCell(value: string): string {
  // RFC 4180: quote any field containing a comma, quote, or newline; escape
  // embedded quotes by doubling them.
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Serialize a header + rows matrix to CSV and trigger a download. */
export function saveCsv(rows: string[][], filename: string): void {
  const csv = rows.map((row) => row.map(csvCell).join(",")).join("\r\n");
  // Prepend a UTF-8 BOM so Excel reads accented characters correctly.
  const blob = new Blob(["﻿" + csv], {
    type: "text/csv;charset=utf-8;",
  });
  saveBlob(blob, filename);
}
